<template>
  <div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'EmptyLayout',
}
</script>



// WEBPACK FOOTER //
// src/components/layout/EmptyLayout.vue